/* eslint-disable no-inline-comments */
/* eslint-disable line-comment-position */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-implicit-globals */
/* eslint-disable no-unused-vars */

var liveAgentDeployment = '';// NOSONAR

/* eslint-enable no-unused-vars */
if (!window._laq) {
  window._laq = [];
}

liveAgentDeployment = false;
window._laq.push(function() {
  var customerSupportStoreId = document.getElementById('ph-customersupportid').value;// NOSONAR

  /* eslint-disable no-undef */
  liveagent.showWhenOnline(customerSupportStoreId, document.getElementById('liveagent_button_online_' + customerSupportStoreId)); // NOSONAR
  liveagent.showWhenOffline(customerSupportStoreId, document.getElementById('liveagent_button_offline_' + customerSupportStoreId)); // NOSONAR
/* eslint-enable no-undef */
});
/* eslint-enable no-inline-comments */
/* eslint-enable line-comment-position */
/* eslint-enable no-underscore-dangle */
/* eslint-enable no-implicit-globals */
